const linkBeingUsed =
  window.location.hostname === "fabricca.pro" ? "recommended" : "alternative";

const linkText =
  linkBeingUsed === "recommended"
    ? "Abrir link alternativo"
    : "Abrir link recomendado";

export const constants = { linkText, linkBeingUsed };
